__turbopack_context__.v({
  "animated": "FounderStory-module__7-DTRG__animated",
  "content": "FounderStory-module__7-DTRG__content",
  "founderContainer": "FounderStory-module__7-DTRG__founderContainer",
  "infoCard": "FounderStory-module__7-DTRG__infoCard",
  "infoItem": "FounderStory-module__7-DTRG__infoItem",
  "infoLabel": "FounderStory-module__7-DTRG__infoLabel",
  "infoValue": "FounderStory-module__7-DTRG__infoValue",
  "paragraph": "FounderStory-module__7-DTRG__paragraph",
  "quote": "FounderStory-module__7-DTRG__quote",
  "quotesSection": "FounderStory-module__7-DTRG__quotesSection",
  "reveal-up": "FounderStory-module__7-DTRG__reveal-up",
  "serviceTag": "FounderStory-module__7-DTRG__serviceTag",
  "servicesCard": "FounderStory-module__7-DTRG__servicesCard",
  "servicesTags": "FounderStory-module__7-DTRG__servicesTags",
  "servicesTitle": "FounderStory-module__7-DTRG__servicesTitle",
  "sidebar": "FounderStory-module__7-DTRG__sidebar",
  "story": "FounderStory-module__7-DTRG__story",
  "title": "FounderStory-module__7-DTRG__title",
});
